import React from "react";
import ReactDOM from "react-dom";
import Influencers from "./exercises/exercise_3_influencers";

ReactDOM.render(
  <React.StrictMode>
    <Influencers />
  </React.StrictMode>,
  document.getElementById("root")
);
